<div class="grid md:grid-cols-4 grid-cols-2 gap-4 justify-center max-w-[858px] w-full">
    <ng-container *ngFor="let button of Buttons">
        <label [attr.for]="button.id" class="visual-checkbox flex flex-col flex-1">
            <input type="checkbox" [attr.id]="button.id" class="opacity-0 absolute h-0 w-0"
                (click)="toggleSelect(button.id)" [checked]="button.isToggled">
            <i class="text-[40px]" [ngClass]="button.icon"></i>
            <span class="">{{button.title}}</span>
        </label>
    </ng-container>
</div>